<template>
  <b-container id="cabecera" fluid>
    <b-row>
      <b-col cols="12" sm="12">
        <b-jumbotron class="text-center">
          <template slot="header">
            <p class="mensajeHeader">
              <strong>{{ mensajeBienvenida + mensaje }}.</strong>
            </p>
          </template>

        </b-jumbotron>
          <b-alert v-if="mensajeInformativo.titulos.length > 0" show variant="success" class="text-center">
            <h2>{{ mensajeInformativo.titulos[0].toUpperCase() }}</h2>
            <h3>{{mensajeInformativo.parrafos[0]}}</h3>


            <hr>
              <h2>{{ mensajeInformativo.titulos[1].toUpperCase() }}</h2>
            <h3>{{mensajeInformativo.parrafos[1].toUpperCase()}}</h3>
          </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-card no-body header="Solicitudes a revisar">
          <b-list-group flush>
            <b-list-group-item class="d-flex justify-content-between align-items-center" to="/consultasolicitud?estado=1">Creadas <b-badge variant="primary" pill>{{cantidadCreadas}}</b-badge></b-list-group-item>
            <b-list-group-item v-if="isInRoleCoordinador || isInRoleAdmin || isInRoleRecMedico" class="d-flex justify-content-between align-items-center" to="/consultasolicitud?estado=4">Enviadas <b-badge variant="primary" pill>{{cantidadEnviadas}}</b-badge></b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center" to="/consultasolicitud?estado=7">Rechazadas <b-badge variant="primary" pill>{{cantidadRechazadas}}</b-badge></b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
function getCantidadByEstado(estado, establecimiento) {
    return Solicitudsvc.getCantidad({
      EstadoSolicitudMedica: estado,
      incluyelicenciacargopersonal: false,
      incluyehistorialsolicitudmedica: false,
      nivelenseñanza_id: establecimiento.NivelEnseñanza_Id,
      unidadeducativa_id: establecimiento.UnidadEducativa_Id,
      unidadadministrativa_id: establecimiento.UnidadAdministrativa_Id,
    }).then(e => {
      console.log("Solicitudsvc.getCantidad then: ", e.data);
      return e.data.objeto.CantidadRegistrosEncontrados;
    }).catch(error => {
      console.log("Error en Solicitudsvc.getCantidad", error.response.data);
      this.errorHandler(error);
    });
}
import errorhandler from "@/helpers/errorhandler";
import { mapGetters } from "vuex";
import Solicitudsvc from "@/services/solicitudes";
export default {
  name: "cabecera",
  mixins: [errorhandler],
  data() {
    return {
      cantidadCreadas: 0,
      cantidadRechazadas: 0,
      cantidadEnviadas: 0,
      mensajeCabecera: "",
      mensaje: "",
      userName: "",
      mensajeBienvenida: "",
      mensajeInformativo: {
        titulos:[
        ],
        parrafos: [
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["getUserInfo", 'getEstablecimiento','isInRoleAdmin','isInRoleCoordinador','isInRoleEstablecimiento','isInRoleRecMedico']),
  },
  methods: {
    checkUsuario() {
      this.mensaje = this.getUserInfo.InformacionPersonal.Nombre;
      if (this.getUserInfo.InformacionPersonal.Sexo == "Femenino") {
        this.mensajeBienvenida = "Bienvenida, ";
      } else {
        this.mensajeBienvenida = "Bienvenido, ";
      }
    }
  },
  created() {
    this.checkUsuario();
    getCantidadByEstado(1, this.getEstablecimiento).then(e => {
      this.cantidadCreadas = e;
    });
    getCantidadByEstado(4, this.getEstablecimiento).then(e => {
      this.cantidadEnviadas = e;
    });
    getCantidadByEstado(7, this.getEstablecimiento).then(e => {
      this.cantidadRechazadas = e;
    });
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/HomeView.vue